import { render, staticRenderFns } from "./FapiaoList.vue?vue&type=template&id=9fdd8a6a&scoped=true&"
import script from "./FapiaoList.vue?vue&type=script&lang=js&"
export * from "./FapiaoList.vue?vue&type=script&lang=js&"
import style0 from "./FapiaoList.vue?vue&type=style&index=0&id=9fdd8a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdd8a6a",
  null
  
)

export default component.exports